import { render, staticRenderFns } from "./examRecords.vue?vue&type=template&id=67c89eec&scoped=true&"
import script from "./examRecords.vue?vue&type=script&lang=js&"
export * from "./examRecords.vue?vue&type=script&lang=js&"
import style0 from "./examRecords.vue?vue&type=style&index=0&id=67c89eec&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c89eec",
  null
  
)

export default component.exports